import { AppSpinner } from "components/AppSpinner/AppSpinner";
import { OnlyActiveSwitch } from "components/OnlyActiveSwitch/OnlyActiveSwitch";
import { CardListSkeleton } from "components/Skeletons/CardListSkeleton";
import { TableSkeleton } from "components/Skeletons/TableSkeleton";
import { useRoleType } from "hooks/useRoleType";
import { useSelectedViewTab } from "hooks/useSelectedViewTab";
import { useAtom } from "jotai";
import { EBenefitTab } from "library/types";
import { ImplementationCardList } from "pages/CompanyBenefitImplementationPage/components/ManageBenefitImplementationsView/ImplementationCardList";
import { useCallback } from "react";
import { onlyActiveImplementationsState } from "store/UIHrPage";
import styled from "styled-components";
import { HrImplementationsTable } from "./HrImplementationsTable";
import { useHrImplementationList } from "./useHrImplementationList";

export function ImplementationsHrView() {
  const selectedBenefitTab = useSelectedViewTab();

  const roles = useRoleType();
  const isReadOnlyUser = roles?.hasReadOnlyRole;

  const [onlyActiveImplementations, setOnlyActiveImplementation] = useAtom(
    onlyActiveImplementationsState
  );

  const {
    implementedBenefits,
    implementationLoading,
    implementationRefetching,
  } = useHrImplementationList();

  const onSetOnlyActiveImplementation = useCallback(
    (value) => {
      setOnlyActiveImplementation(value);
    },
    [setOnlyActiveImplementation]
  );

  const loading = implementationLoading || !implementedBenefits;

  const isListBenefitTabView = selectedBenefitTab === EBenefitTab.list;
  const LoadingSkeleton = isListBenefitTabView ? (
    <TableSkeleton />
  ) : (
    <CardListSkeleton cardNumber={10} />
  );

  return (
    <>
      {implementationRefetching ? <AppSpinner /> : null}
      {loading ? (
        LoadingSkeleton
      ) : (
        <>
          <OnlyActiveSwitch
            value={onlyActiveImplementations}
            setValue={onSetOnlyActiveImplementation}
          />
          <div
            style={{
              marginTop: "10px",
            }}
          >
            {isListBenefitTabView ? (
              <HrImplementationsTable
                implementedBenefits={implementedBenefits}
                previewMode={isReadOnlyUser}
              />
            ) : (
              <ImplementationCardList
                withPagination={implementedBenefits?.length > 50}
                benefitImplementations={implementedBenefits}
                previewMode={isReadOnlyUser}
              />
            )}
          </div>
        </>
      )}
    </>
  );
}

const TableWrap = styled.div`
  margin-top: 10px;
  table {
    td:nth-of-type(3),
    th:nth-of-type(3) {
      position: sticky;
      left: 320px;
      z-index: 1;
      background: inherit;
      box-shadow: 16px 0px 32px 0px rgba(5, 54, 69, 0.06);
    }
    .selected-row {
      background-color: ${({ theme }) => theme.palette.themeLighter} !important;
    }
  }
`;
